<template>
  <div  :class="{ 'mb-9': ((roleInSpace == 'space_admin' || roleInSpace == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial') || roleInSpace == 'space_admin' && subscriptionEnds || (role == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')) }">
    <AlertMessages
      v-if="alertValue"  
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <SystemBarTopTrial v-if="(roleInSpace == 'space_admin' || roleInSpace == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial'"/>
    <SystemBarTopCancelSubscription v-if="roleInSpace == 'space_admin' && subscriptionEnds"/>
    <SystemBarTopPaymentFailed v-if="roleInSpace == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')"/>
    <nav v-if="flexibleData && !isAuth">
      <FlexibleActivityPopup data-testid="popup-flexible-login" />
    </nav>
    <v-app-bar
      app
      clipped-left
      clipped-right
      elevation="0"
      outlined
      v-if="!loadingData"
    > 
     <v-tooltip
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              min-width="52"
              rounded
              elevation="0"
              class="pa-2 ml-n2"
              :color="mobile() ? '#F0F0F0' : ''"
              data-testid="exit-button"    
              v-bind="attrs"
              @click="exitActivity"
              v-on="on">
            <v-icon>
                mdi-chevron-left
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('exitActivityTooltip') }}</span>
        </v-tooltip> 
    
      <v-toolbar-title class="ml-n3">
        <router-link
          v-if="!mobile()"
          to="/"
        >
          <v-img
            v-if="logo == null"
            data-testid="logo-space"
            src="../assets/rtplogo.svg"
            max-height="40"
            :max-width="mobile() ? '40' : '150' "
            class="d-none d-sm-block mx-4 justify-center"
            contain
            position="top left"
          />
          <v-img
            v-else
            data-testid="logo-space"
            :src="logo"
            max-height="40"
            :max-width="mobile() ? '40' : '150' "
            class="d-none d-sm-block mx-4 justify-center"
            contain
            position="top left"
          />
        </router-link>
         <router-link
          v-else
          to="/"
        >
          <v-img
            v-if="icon == null"
            data-testid="logo-space"
            src="../assets/rtpicon.png"
            max-height="20"
            :max-width="mobile() ? '20' : '20' "
            class="justify-center mx-6"
            contain
            position="top left"
          />
          <v-img
            v-else
            data-testid="logo-space"
            :src="icon"
            max-height="20"
            :max-width="mobile() ? '20' : '20' "
            class="justify-center mx-6"
            contain
            position="top left"
          />
        </router-link>
      </v-toolbar-title>
      <h3
        v-if="!mobile() && role == 'booster'"
        class="pl-6 no-break activity-title activity-title-edit"
      >
        <div >
          <v-clamp
            v-if="showActivityTitle==false"
            autoresize
            :max-lines="2"
            @dblclick.native="counter += 2, showEditTitleField()"
          >
            {{ activityTitle }}
          </v-clamp>
          <v-form
            v-if="showActivityTitle==true"
            ref="form"
            v-model="valid"            
            @submit.prevent
            @keydown.enter.prevent
          >
            <v-text-field
              v-model="activityTitle"
              autofocus
              data-testid="title-input"
              class="mt-0 pt-0"
              hide-details
              v-focus-outside="onClickOutside"
              :append-icon="valid ? 'mdi-check-bold' : ''"
              :rules="titleRules"
              @click:append="editTitle()"
              @keydown.enter="editTitle()"
              @click.stop.prevent
              @keydown.enter.stop.prevent
            />
          </v-form>
          <v-tooltip
            v-if="showActivityTitle==false"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                data-testid="edit-activity-title-button"
                icon
                class="ml-1 dots-vertical"
                small
                v-bind="attrs"
                v-on="on"
                @click.stop.prevent="showEditTitleField()"
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('editActivityTooltip') }}</span>
          </v-tooltip>
        </div>
      </h3>
      <h3
        v-if="!mobile() && role != 'booster'"
        class="pl-6 no-break activity-title-edit"
      >
        <v-clamp
          autoresize
          :max-lines="2"
        >
          {{ activityTitle }}
        </v-clamp>
      </h3>
      <h4
        v-if="mobile()"
        style="font-size:14px"
        class="pl-3 no-break"
      >
        <v-clamp
          autoresize
          :max-lines="1"
        >
          {{ activityTitle }}
        </v-clamp>
      </h4>
      <v-tooltip
        v-if="!mobile() && role == 'booster'"
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-chip
            small
            data-testid="sharing-setting-chip"
            color="darktext"
            text-color="white"
            filter-icon="mdi-equalizer-outline"
            class="ml-4 sharing-setting-chip"
            v-on="on"
            @click.stop="
              dialogVisibleChangeSharingSettings = true, 
              confirmationDialogTitle=$t('confirmationDialogTitleChangeSharingSettings'),
              confirmationDialogSubmitBtn=$t('save')
              confirmationDialogCancelBtn=$t('cancel')"
          >
            <v-icon
              size="14"
              class="pr-1"
            >
              mdi-share-variant
            </v-icon>
            {{ activityTypeName }}
          </v-chip>
        </template>
        <span>{{ $t('sharingSettingsChipTooltip') }}</span>
      </v-tooltip>
      <v-chip
        v-if="!mobile() && role != 'booster' && isAuth"
        small
        data-testid="sharing-setting-chip"
        color="darktext"
        text-color="white"
        filter-icon="mdi-equalizer-outline"
        class="ml-4 sharing-setting-chip">
        <v-icon
          size="14"
          class="pr-1"
        >
          mdi-share-variant
        </v-icon>
        {{ activityTypeName }}
      </v-chip>
      <v-avatar data-testid="eduadmin-icon" size="20" class="ml-4" v-if="role == 'booster' && eduadminConnectionAvailable">
        <v-img
          src="../assets/EduAdmin_orginal.png"
        />
      </v-avatar>
      <v-spacer />
      <div v-if="isAuth">
        <v-tooltip
          v-if="certificateEnabled == true && role != 'booster' && !mobile()"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              data-testid="certificate-icon-download-button"
              rounded
              elevation="0"
              v-bind="attrs"
              @click="downloadCertificate"
              v-on="on"
            >
              <v-icon
                :disabled="!certificateAvailable"
                data-testid="certificate-icon"
              >
                mdi-certificate-outline
              </v-icon>
            </v-btn>
          </template>
          <span v-if="certificateAvailable">{{ $t('certificateInActivityAvailableTooltip') }}</span>
          <span v-else>{{ $t('certificateInActivityNotAvailableTooltip') }}</span>
        </v-tooltip>
        <div class="d-inline-flex">
          <div
            v-for="item of sortedDuplicateUsers.slice(0, 5)"
            :key="item.user_id"            
            data-testid="editor-user"
            class="text-center align-self-center ml-n2"
          >
            <v-tooltip
              v-if="role == 'booster' && !mobile()"
              data-testid="liveusers"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-avatar
                  size="37"
                  :style="`bottom:5px;border:3px solid; color: #`+ intToRGB(hashCode(item.first_name + item.last_name))"
                  class="avatar"
                  v-bind="attrs"
                  v-on="on"
                >
                  <img
                    v-if="item.avatar == null"
                    src="../assets/user_images/profile-avatar.png"
                  >
                  <img
                    v-else
                    :src="item.avatar"
                  >
                </v-avatar>
              </template>
              <span>{{ item.first_name+ ' '+ item.last_name }} {{ $t('someoneIsWorking') }}</span>
            </v-tooltip>
          </div>
        </div>

        <div class="d-inline-flex activity-settings-menu">
        <ContactUs v-if="(role == 'booster' || role == 'space_admin') && !mobile()" />
        <v-tooltip
          v-if="!mobile() && (role == 'booster' || (role != 'booster' && can_view_analytics == true))"
          data-testid="analytics-icon"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              rounded
              elevation="0"
              v-bind="attrs"
              @click="openPeopleInActivity"
              v-on="on"
            >
              <v-icon>mdi-equalizer-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('analyticsInActivityTooltip') }}</span>
        </v-tooltip>
        <v-menu
          v-if="!mobile() && role == 'booster'"
          data-testid="share-activity-icon"
          offset-y
          flat
        >
          <template v-slot:activator="{ on: menu }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  data-testid="share-activity-button"
                  rounded
                  elevation="0"
                  v-on="{ ...tooltip, ...menu }"
                >
                  <v-icon>mdi-share-variant</v-icon>
                  <v-icon data-testid="sync-error" v-if="eduadminConnectionAvailable && eduadminConnectionError" color="red" size="12" style="position: absolute; right: -5px; top: -5px;">
                   mdi-alert
                  </v-icon>                    
                </v-btn>
              </template>
              <span>{{ $t('shareActivityTooltip') }}</span>
            </v-tooltip>
          </template>
          <v-list
            data-testid="menu-list"
          >
            <v-list-item
              router
              :to="'/activity/'+ $route.params.id + '/owners/add'"
              data-testid="add-owners-activity-item"
              :disabled="productPlan.attributes && productPlan.attributes.name == 'Free'"
            >
              <v-list-item-title class="pr-2">
                {{ $t('addOwners') }}
                <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="px-2" x-small color="accent" style="position: relative;" text-color="white">PRO</v-chip>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              router
              :to="'/activity/'+ $route.params.id + '/share'"
              data-testid="share-activity-item"
            >
              <v-list-item-title class="pr-2">
                {{ $t('directShare') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="showCopiedLink"
              data-testid="copy-link-item"
              @click="copySharingLink()"
            >
              <v-list-item-title class="pr-2">
                {{ $t('copySharingLink') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="showCopiedLink"
              data-testid="share-csv-activity-item"
              router
              :to="'/activity/'+ $route.params.id + '/share-csv'"
              :disabled="productPlan.attributes && productPlan.attributes.name == 'Free'"
            >
              <v-list-item-title class="pr-2">
                {{ $t('csvShare') }}
                <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="px-2" x-small color="accent" style="position: relative;" text-color="white">PRO</v-chip>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="role == 'booster'"
              router
              :to="'/activity/'+ $route.params.id + '/qr-code'"
              data-testid="qr-code-item"
            >
              <v-list-item-title class="pr-2">
                {{ $t('qrCode') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="role == 'booster'"
              router
              :to="'/activity/'+ $route.params.id + '/connected-hubs'"
              data-testid="connected-hubs-activity-item"
              :disabled="productPlan.attributes && productPlan.attributes.name == 'Free'"
            >
              <v-list-item-title class="pr-2">
                {{ $t('connectedHubs') }}
                <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="px-2" x-small color="accent" style="position: relative;" text-color="white">PRO</v-chip>
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="role == 'booster' && productPlan.attributes && productPlan.attributes.eduadmin_integration == 1"
              router
              :to="'/activity/'+ $route.params.id + '/eduadmin'"
              data-testid="eduadmin-item"
            >
              <v-list-item-title class="pr-2">
                {{ $t('eduAdmin') }}
                <v-icon v-if="eduadminConnectionAvailable && eduadminConnectionError" color="red" size="12" style="top: -5px;">
                  mdi-alert
                </v-icon> 
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu
          v-if="!mobile() && role != 'booster' && (can_share == true || showCopiedLink || (productPlan.attributes && productPlan.attributes.name != 'Free' && role == 'participant' && (roleInSpace == 'booster' || roleInSpace == 'space_admin')))"
          data-testid="share-activity-icon"
          offset-y
          flat
        >
          <template v-slot:activator="{ on: menu }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  data-testid="share-activity-button"
                  rounded
                  elevation="0"
                  v-on="{ ...tooltip, ...menu }"
                >
                  <v-icon>mdi-share-variant</v-icon>                 
                </v-btn>
              </template>
              <span>{{ $t('shareActivityTooltip') }}</span>
            </v-tooltip>
          </template>
          <!-- participant/guest -->
          <v-list
            data-testid="menu-list"
          >
          <v-list-item
            v-if="can_share == true"
              router
              :to="'/activity/'+ $route.params.id + '/share'"
              data-testid="share-activity-item"
            >
              <v-list-item-title class="pr-2">
                {{ $t('directShare') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="showCopiedLink"
              data-testid="copy-link-item"
              @click="copySharingLink()"
            >
              <v-list-item-title class="pr-2">
                {{ $t('copySharingLink') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="productPlan.attributes && productPlan.attributes.name != 'Free' && role == 'participant' && (roleInSpace == 'booster' || roleInSpace == 'space_admin')"
              data-testid="request-owner-item"
              @click.stop="
                dialogRequestOwnerRights = true, 
                confirmationDialogTitle = $t('confirmationDialogTitleRequestOwnerRights'), 
                confirmationDialogText = $t('confirmationDialogTextRequestOwnerRights'), 
                confirmationDialogSubmitBtn = $t('send'),
                confirmationDialogCancelBtn = $t('cancel'),
                cdSubmitBtnColor='accent',
                cdCancelBtnColor='darktext'"
            >
              <v-list-item-title class="pr-2">
                {{ $t('requestOwnerRights') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn 
          v-if="!mobile() && sharingSetting == 1"
          data-testid="info-owners-button"
          rounded
          elevation="0"
          @click="dialogVisibleOwners = true"
        >
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
        <v-tooltip
          v-if="role == 'booster' && !mobile()"
          data-testid="settings-icon"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              rounded
              elevation="0"
              v-bind="attrs"
              data-testid="settings-button"
              @click="openActivitySettingsDialog"
              v-on="on"
            >
              <v-icon>mdi-cog</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('settingsEditPageTooltip') }}</span>
        </v-tooltip>
        </div>
        <!--booster mobile -->
        <span class="float-right">
          <v-menu
            v-if="mobile() && role == 'booster'"
            offset-y
            rounded-lg
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-3"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>mdi-menu-down</v-icon>
              </v-btn>
            </template>

            <v-list
              class="menulist-drawer"
              data-testid="menu-list"
            ><v-list-item @click="openPeopleInActivity">
               <v-list-item-title>{{ $t('overview') }}</v-list-item-title>
             </v-list-item>          
              <v-list-item :to="'/activity/'+ $route.params.id + '/owners/add'" :disabled="productPlan.attributes && productPlan.attributes.name == 'Free'">
                <v-list-item-title>{{ $t('addOwners') }}
                  <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="px-2" x-small color="accent" style="position: relative;" text-color="white">PRO</v-chip>
                </v-list-item-title>
              </v-list-item>
              <v-list-item :to="'/activity/'+ $route.params.id + '/share'">
                <v-list-item-title>{{ $t('directShare') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="showCopiedLink"
                @click="copySharingLink()"
              >
                <v-list-item-title>{{ $t('copySharingLink') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="showCopiedLink"
                :to="'/activity/'+ $route.params.id + '/share-csv'"
                :disabled="productPlan.attributes && productPlan.attributes.name == 'Free'"
              >
                <v-list-item-title>{{ $t('csvShare') }}
                  <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="px-2" x-small color="accent" style="position: relative;" text-color="white">PRO</v-chip>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="role == 'booster'" :to="'/activity/'+ $route.params.id + '/qr-code'">
                <v-list-item-title>{{ $t('qrCode') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="role == 'booster'" :to="'/activity/'+ $route.params.id + '/connected-hubs'" :disabled="productPlan.attributes && productPlan.attributes.name == 'Free'">
                <v-list-item-title>{{ $t('connectedHubs') }}
                  <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="px-2" x-small color="accent" style="position: relative;" text-color="white">PRO</v-chip>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="role == 'booster' && productPlan.attributes && productPlan.attributes.eduadmin_integration == 1" :to="'/activity/'+ $route.params.id + '/eduadmin'">
                <v-list-item-title>
                  {{ $t('eduAdmin') }}
                  <v-icon v-if="eduadminConnectionAvailable && eduadminConnectionError" color="red" size="12" style="top: -5px;">
                   mdi-alert
                  </v-icon> 
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="sharingSetting == 1" @click="dialogVisibleOwners = true">
                <v-list-item-title>{{ $t('owners') }}</v-list-item-title>
              </v-list-item>
               <v-list-item
                target="_blank"
                href="https://skillboost.io/kom-igang/"
              >
                <v-list-item-title class="pr-2">
                  {{ $t('tutorialsLiveChat') }}
                </v-list-item-title>
              </v-list-item>
             </v-list>
          </v-menu>

          <!--participant/guest mobile -->
          <v-menu
            v-if="mobile() && role != 'booster' && (can_share == true || showCopiedLink || (productPlan.attributes && productPlan.attributes.name != 'Free' && role == 'participant' && (roleInSpace == 'booster' || roleInSpace == 'space_admin')))"
            offset-y
            rounded-lg
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-3"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>mdi-menu-down</v-icon>
              </v-btn>
            </template>

            <v-list
              class="menulist-drawer"
              data-testid="menu-list"
            >
             <v-list-item @click="openPeopleInActivity" v-if="can_view_analytics == true">
               <v-list-item-title>{{ $t('overview') }}</v-list-item-title>
             </v-list-item>
             <v-list-item v-if="sharingSetting == 1" @click="dialogVisibleOwners = true">
                <v-list-item-title>{{ $t('owners') }}</v-list-item-title>
              </v-list-item>
             <v-list-item v-if="can_share == true" :to="'/activity/'+ $route.params.id + '/share'">
                <v-list-item-title>{{ $t('directShare') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="showCopiedLink"
                @click="copySharingLink()"
              >
                <v-list-item-title>{{ $t('copySharingLink') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="productPlan.attributes && productPlan.attributes.name != 'Free' && role == 'participant' && (roleInSpace == 'booster' || roleInSpace == 'space_admin')"
                @click.stop="
                  dialogRequestOwnerRights = true, 
                  confirmationDialogTitle = $t('confirmationDialogTitleRequestOwnerRights'), 
                  confirmationDialogText = $t('confirmationDialogTextRequestOwnerRights'), 
                  confirmationDialogSubmitBtn = $t('send'),
                  confirmationDialogCancelBtn = $t('cancel'),
                  cdSubmitBtnColor='accent',
                  cdCancelBtnColor='darktext'"
              >
                <v-list-item-title class="pr-2">
                  {{ $t('requestOwnerRights') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="certificateAvailable"
                @click="downloadCertificate"
              >
                <v-list-item-title>{{ $t('certificateInActivityAvailableTooltip') }}</v-list-item-title>
              </v-list-item>   
            </v-list>
          </v-menu>
        </span>
      </div>
      <div v-else>
        <v-menu
          v-if="!mobile() && showCopiedLink"
          data-testid="share-activity-icon"
          offset-y
          flat
        >
          <template v-slot:activator="{ on: menu }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  data-testid="share-activity-button"
                  rounded
                  elevation="0"
                  v-on="{ ...tooltip, ...menu }"
                >
                  <v-icon>mdi-share-variant</v-icon>                 
                </v-btn>
              </template>
              <span>{{ $t('shareActivityTooltip') }}</span>
            </v-tooltip>
          </template>
          <v-list data-testid="menu-list">
            <v-list-item    
              v-if="showCopiedLink"          
              data-testid="copy-link-item"
              @click="copySharingLink()"
            >
              <v-list-item-title class="pr-2">
                {{ $t('copySharingLink') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          v-if="!mobile() && sharingSetting == 1"
          data-testid="info-owners-button"
          rounded
          elevation="0"
          @click="dialogVisibleOwners = true"
        >
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
        <v-tooltip
          v-if="!mobile()"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              ref="loginDialog"
              data-testid="login-button"
              rounded
              elevation="0"
              v-bind="attrs"
              v-on="on"
              @click="
                dialogVisible=true, 
                confirmationDialogTitle=$t('confirmationDialogTitleWithoutLogin'), 
                confirmationDialogText=$t('confirmationDialogTextWithoutLogin'),
                cdSubmitBtnColor='accent', 
                cdCancelBtnColor='darktext',
                confirmationDialogSubmitBtn=$t('login')
                confirmationDialogLinkBtn=$t('createNewAccount')
                confirmationDialogCancelBtn=$t('skip')"
            >
              {{ $t('login') }}
              <v-icon>mdi-login</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('login') }}</span>
        </v-tooltip>
        <v-menu
          v-if="mobile()"
          offset-y
          rounded-lg
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class=" px-5 py-3"
              height="100%"
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon large>
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>

          <v-list
            class="menulist-drawer"
            data-testid="menu-list"
          >
            <v-list-item
              v-if="showCopiedLink"
              @click="copySharingLink()"
            >
              <v-list-item-title>{{ $t('copySharingLink') }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              ref="loginDialog"
              data-testid="login-button"
              rounded
              elevation="0"
              @click="
                dialogVisible=true, 
                confirmationDialogTitle=$t('confirmationDialogTitleWithoutLogin'), 
                confirmationDialogText=$t('confirmationDialogTextWithoutLogin'),
                cdSubmitBtnColor='accent', 
                cdCancelBtnColor='darktext',
                confirmationDialogSubmitBtn=$t('login')
                confirmationDialogLinkBtn=$t('createNewAccount')
                confirmationDialogCancelBtn=$t('skip')"
            >
              <v-list-item-title>{{ $t('login') }} <v-icon>mdi-login</v-icon></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <ConfirmationDialog
        v-if="dialogRequestOwnerRights"
        :visible="dialogRequestOwnerRights"
        :cd-title="confirmationDialogTitle"
        :cd-text="confirmationDialogText"
        :cd-submit-btn="confirmationDialogSubmitBtn"
        :cd-cancel-btn="confirmationDialogCancelBtn"
        :cd-cancel-btn-color="cdCancelBtnColor"
        :cd-submit-btn-color="cdSubmitBtnColor"
        data-testid="request-owners-rights-dialog" 
        @proceedSubmit="sendRequestOwnerRights"
        @close="dialogRequestOwnerRights =false"
    />

    <ConfirmationDialogOwnersInActivity 
        v-if="dialogVisibleOwners"
        :visible="dialogVisibleOwners" 
        data-testid="owners-dialog" 
        @close="dialogVisibleOwners =false"
        @proceedError="showErrorMessage"
    />

    <ConfirmationDialogWithLink 
      v-if="dialogVisible"
      ref="confirmationDialogWithLink"
      :visible="dialogVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText" 
      :cd-submit-btn="confirmationDialogSubmitBtn" 
      :cd-link-btn="confirmationDialogLinkBtn" 
      :cd-cancel-btn="confirmationDialogCancelBtn" 
      :cd-cancel-btn-color="cdCancelBtnColor" 
      :cd-submit-btn-color="cdSubmitBtnColor"
      :cd-idps="idps"
      :cd-entity-id="activityId"
      :cd-entity-type="entityType"
      data-testid="confirmation-dialog-link" 
      @clickOutSide="dialogVisible=false"
      @close="dialogVisible=false"
      @proceedSubmit="login"
      @proceedLink="createNewAccount"
    />
    <ConfirmationDialogChangeSharingSettings
        v-if="dialogVisibleChangeSharingSettings"
        ref="confirmationDialogChangeSettings"
        :visible="dialogVisibleChangeSharingSettings"
        :cd-title="confirmationDialogTitle" 
        :cd-submit-btn="confirmationDialogSubmitBtn" 
        :cd-cancel-btn="confirmationDialogCancelBtn" 
        :loading="loadingUpdate"
        :activity-sharing-settings="sharingSetting"
        type="activity"
        data-testid="confirmation-dialog-change-sharing-settings" 
        @close="dialogVisibleChangeSharingSettings= false"
        @proceedSubmit="changeSharingSettings"
      /> 
      <EditActivity
        v-if="isAuth && role == 'booster' && visibleDialogActivitySettingsDialog && !mobile()"
        :visible="visibleDialogActivitySettingsDialog"
        :activity-id="activityId"
        :activity-title="activityTitle"
        :activity-image-u-r-l="coverImage"
        :activity-image-path="coverPath"
        :activity-sharing-settings="sharingSetting"
        :activity-checkbox-forum="checkboxForum"
        :activity-checkbox-certificate="checkboxCertificate"
        :activity-tags="tags"
        :change-activity-menu="true"
        @close="visibleDialogActivitySettingsDialog= false"
        @proceedSubmit="updateActivity"
      />

      <NavbarForum
        v-if="(checkboxForum && !isAuth && sharingSetting == 3) || (checkboxForum && isAuth)"
        :activity-id="activityId"
        class="activity-forum activity-forum-button-1"
      />     
  </div>
</template>

<script>
import {eventBus} from '../eventbus'
import VClamp from 'vue-clamp'
import ConfirmationDialogWithLink from './ConfirmationDialogWithLink.vue'
import { getActivity, updateActivity, getCeftificateCompletionDate, createRequestToBecomeOwner } from '../api/activityApi'
import i18n from '../plugins/i18n'
import jsPDF from 'jspdf'
import AlertMessages  from './AlertMessages'
import { getSpaceByURL } from '../api/spaceApi'
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
// import Vue from 'vue'
import { ruleRequired, ruleValidMin2Max70Characters } from '../rules/formRules.js';
import SystemBarTopTrial from '../components/SystemBarTopTrial';
import SystemBarTopCancelSubscription from '../components/SystemBarTopCancelSubscription'
import SystemBarTopPaymentFailed from '../components/SystemBarTopPaymentFailed'
import ConfirmationDialogChangeSharingSettings from './ConfirmationDialogChangeSharingSettings.vue'
import EditActivity from '../views/activities/EditActivity'
import NavbarForum from '../components/NavbarForum'
import FlexibleActivityPopup from '../components/FlexibleActivityPopup'
import focusOutside from 'vue-focus-outside'
import ContactUs from '../components/ContactUs';
import ConfirmationDialogOwnersInActivity from "../components/ConfirmationDialogOwnersInActivity.vue";
import ConfirmationDialog from "../components/ConfirmationDialog.vue";

export default {
    components: {
        VClamp,
        ConfirmationDialogWithLink,
        AlertMessages,
        SystemBarTopTrial,
        SystemBarTopCancelSubscription,
        SystemBarTopPaymentFailed,
        ConfirmationDialogChangeSharingSettings,
        EditActivity,
        NavbarForum,
        FlexibleActivityPopup,
        ContactUs,
        ConfirmationDialogOwnersInActivity,
        ConfirmationDialog
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
          valid: true,
            titleRules: ruleRequired('labelTitle').concat(ruleValidMin2Max70Characters('labelTitle')),
            cookie:false,
            isAuth: window.$cookies.get("token")? true: false,
            drawer: null,
            activityTitle: '',
            userId: window.$cookies.get('id'),
            spaceId: window.$cookies.get('space_id'),
            activityId: this.$route.params.id,
            space: window.location.host.split('.')[0],
            subscriptionEnds: localStorage.space? JSON.parse(localStorage.space).subscription_ends_at: '',
            logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
            icon: localStorage.space ? JSON.parse(localStorage.space).icon : null,
            roleInSpace: localStorage.space ? JSON.parse(localStorage.space).role : null,
            idps: localStorage.space ? JSON.parse(localStorage.space).idps : [],
            entityType: "activity",
            alertMsg: '',
            alertType: '',
            alertValue:false,
            showCopiedLink: false,
            showExitLinkForKb: this.$route.params.successfullySearchActivity,
            showHubexitbtn : false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            confirmationDialogLinkBtn:'',
            cdSubmitBtnColor:'',
            cdCancelBtnColor:'',
            dialogVisible: false,
            loadingData: false,
            activityType:'',
            activityTypeName:'',
            activityTypeTooltip:'',
            role:'',
            certificateAvailable: false,
            showCertificateComponent: false,
            certificateEnabled:false,
            email: localStorage.user ? JSON.parse(localStorage.user).email : '',
            first_name: localStorage.user ? JSON.parse(localStorage.user).first_name : '',
            last_name: localStorage.user ? JSON.parse(localStorage.user).last_name : '',
            avatar: localStorage.user ? JSON.parse(localStorage.user).avatar_thumb : null,
            language: localStorage.user ? JSON.parse(localStorage.user).language : '',
            site_url: window.location.origin,
            costumer_name:localStorage.space ? JSON.parse(localStorage.space).subdomain : '',
            exitPath: null,
            showActivityTitle:false,
            counter: 0,
            dialogVisibleChangeSharingSettings: false,
            title: '',
            coverImage: null,
            coverPath: null,
            sharingSetting: null,
            checkboxForum: true,
            checkboxCertificate: false,
            tags: [],
            visibleDialogActivitySettingsDialog: false,
            loadingUpdate: false,
            flexibleData: false,
            can_share:false,
            can_view_analytics: false,
            eduadminConnectionAvailable: false,
            eduadminConnectionError: false,
            dialogVisibleOwners: false,
            dialogRequestOwnerRights: false,
        }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.name
      })
    },
    computed: {
        listLiveUsers() {
            return this.$store.state.list
        },
        sortedDuplicateUsers() {
            const items = this.listLiveUsers.reduce((p,c) => {
              p[c.user_id] = c
              return p
            }, {})
            return Object.values(items).sort((a,b) => a.user_id.toString().localeCompare(b.user_id))
        },
        productPlan() {
            return this.$store.state.productPlan;
        }
    },

    async created(){
        eventBus.$on('setActivityExitBtn',(data)=>{
            if(this.exitPath == null){
                this.exitPath = data.path
            }
        }),
        /* eslint-disable no-unused-vars */
        eventBus.$on('checkUpdates',async (completedItem, certificate)=>{
            if(certificate && !this.certificateAvailable){
                const response = await getActivity(this.activityId)
                this.certificateAvailable = response.data.data.attributes.certificate_available
                if(this.certificateAvailable){
                    this.alertMsg = i18n.t('certificateAvailableMsg');
                    this.alertType = 'success' 
                    this.alertValue = true  
                }
            }
        }),
        /* eslint-enable no-unused-vars */

        this.loadingData = true
        
        await this.getActivity()

        this.loadingData = false     
    },
    beforeDestroy() {
        eventBus.$off('setActivityExitBtn')
        eventBus.$off('checkUpdates')
    },
    directives: {
      focusOutside
    },
    methods:{
        openActivitySettingsDialog(){
            this.visibleDialogActivitySettingsDialog = true
        },
        showEditTitleField(){
         this.showActivityTitle = true
        },
        async onClickOutside () {
          await this.getActivity()
          this.showActivityTitle = false
        },
        copySharingLink(){
            const el = document.createElement('textarea');  
            el.value = window.location.origin +'/activity/'+this.activityId
            document.body.appendChild(el);                          
            el.select();                                    
            document.execCommand('copy');                   
            document.body.removeChild(el);                  
            this.alertMsg = i18n.t('copySharingLinkSuccessMsg');
            this.alertType = 'success' 
            this.alertValue = true  
        },
       
        exitActivity(){
            if (this.exitPath !== null) {
                this.$router.push({path: this.exitPath})
            } else {
                this.$router.push({path: '/'}) 
            }
        },
        openPeopleInActivity(){
            this.$router.push({path: '/activity/' + this.$route.params.id + '/overview'})
        },
        createNewAccount(){
            window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/register?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId 
        },
        login(){
            window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/login?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId
        },
        async downloadCertificate(){
            const response = await getActivity(this.activityId)
            this.certificateAvailable = response.data.data.attributes.certificate_available
            const response_date = await getCeftificateCompletionDate(this.activityId)
            if(this.certificateAvailable){
                const responseSpace = await getSpaceByURL(this.space)
                var newLogo = responseSpace.data.data.attributes.logo
                var newSubdomain = responseSpace.data.data.attributes.subdomain
                var logo = newLogo ? logo = newLogo + '?notfromcache' : logo = require('../assets/rtplogo.svg')
                let name = localStorage.user ? JSON.parse(localStorage.user).first_name + ' ' + JSON.parse(localStorage.user).last_name : 'null'
                let domain = newSubdomain ? newSubdomain + '.' + process.env.VUE_APP_DOMAIN : process.env.VUE_APP_DOMAIN
                if (name && name != ' ' && logo && this.activityTitle) {
                    var RobotoFont = require('./RobotoFont')
                    var robotoFont = new RobotoFont.RobotoFont()
                    var font = robotoFont.getFont()
                    var callAddFont = function () {
                    this.addFileToVFS('Roboto-Regular-normal.ttf', font);
                    this.addFont('Roboto-Regular-normal.ttf', 'Roboto-Regular', 'normal');
                    };
                    jsPDF.API.events.push(['addFonts', callAddFont])

                    var doc = new jsPDF()
                    let pdfName = 'Certificate_' + this.activityTitle + '_' + name

                    var width = doc.internal.pageSize.getWidth()
                    let pageHeight = doc.internal.pageSize.getHeight()
                    
                    let certificateTextPart1 = i18n.t('certificateTextPart1');
                    let certificateTextPart2 = i18n.t('certificateTextPart2');
                    let certificateTextPart3 = i18n.t('certificateTextPart3');
                    let certificateTextDate = i18n.t('certificateTextDate');

                    doc.setFont('Roboto-Regular', 'normal');
                    doc.setTextColor(0, 0, 0, 0.80)
                    doc.setFontSize(16)
                    doc.text(certificateTextPart1, width/2, 80, { align: 'center', maxWidth: width-30 })
                    doc.setFontSize(22)
                    doc.text(name, width/2, 100, { align: 'center', maxWidth: width-30 })
                    doc.setFontSize(16)
                    doc.text(certificateTextPart2, width/2, 120, { align: 'center', maxWidth: width-30 })
                    doc.setFontSize(22)
                    doc.text(this.activityTitle, width/2, 140, { align: 'center', maxWidth: width-30 })
                    doc.setFontSize(16)
                    doc.text(certificateTextPart3, width/2, 170, { align: 'center', maxWidth: width-30 })
                    doc.text(certificateTextDate + ': ' + response_date.data.data[0].attributes.created_at.slice(0, 10), width/2, 230, { align: 'center', maxWidth: width-30 })
                    doc.text(domain, width/2, pageHeight-20, { align: 'center', maxWidth: width-30 })

                    if (logo.split(/[#?]/)[0].split('.').pop().trim() == 'svg') {
                        var XMLrequest = new XMLHttpRequest() // new XML request
                        XMLrequest.crossOrigin = "anonymous"
                        XMLrequest.open("GET", logo, false) // URL of the SVG file on server
                        XMLrequest.send(null) // get the SVG file

                        var mySVG = XMLrequest.responseXML.getElementsByTagName("svg")[0]

                        var svgString = new XMLSerializer().serializeToString(mySVG)

                        var data = "data:image/svg+xml;utf8," + encodeURIComponent(svgString);

                        var canvas = document.createElement('canvas')
                        var svgwidth = mySVG.width.baseVal.value
                        var svgheight = mySVG.height.baseVal.value
                        canvas.width = svgwidth
                        canvas.height = svgheight

                        var ctx = canvas.getContext("2d")
                        ctx.clearRect(0, 0, canvas.width, canvas.height)
                        
                        var img = new Image()
                        img.src = data
                   
                        img.onload = function() {
                            let devide = this.height/28
                            let imageWidth = this.width/devide
                            ctx.drawImage(img, 0, 0)
                            var png = canvas.toDataURL("image/png")
                            doc.addImage(png, width/2-imageWidth/2, 20, imageWidth, 28)
                            doc.save(pdfName + '.pdf')
                        }
                    } else if (logo.split(/[#?]/)[0].split('.').pop().trim() == 'jpg' ||
                        logo.split(/[#?]/)[0].split('.').pop().trim() == 'jpeg' || 
                        logo.split(/[#?]/)[0].split('.').pop().trim() == 'png') {
                            let img = new Image
                            img.src = logo
                            img.crossOrigin = "anonymous"

                            img.onload = function() {
                                let devide = this.height/28
                                let imageWidth = this.width/devide
                                doc.addImage(this, width/2-imageWidth/2, 20, imageWidth, 28)
                                doc.save(pdfName + '.pdf')
                            }                           
                    }
                }
            }           
        },
        async getActivity(){
            try {
                const response = await getActivity(this.activityId)
                if(response.status == 200) {
                    this.activityTitle = response.data.data.attributes.title
                    this.activityType = response.data.data.attributes.sharing_setting
                    this.role = response.data.data.attributes.role,
                    this.certificateAvailable = response.data.data.attributes.certificate_available
                    this.certificateEnabled = response.data.data.attributes.certificate_enabled
                    this.title = response.data.data.attributes.title
                    this.coverImage = response.data.data.attributes.image
                    this.sharingSetting = response.data.data.relationships['sharing-setting'].data.id
                    this.checkboxForum =response.data.data.attributes.forum_enabled
                    this.checkboxCertificate =response.data.data.attributes.certificate_enabled
                    this.tags = response.data.data.attributes.tags
                    this.can_share = response.data.data.attributes.can_share
                    this.can_view_analytics = response.data.data.attributes.can_view_analytics
                    if(response.data.data.relationships['activity-connections']){
                      this.eduadminConnectionAvailable = true
                      this.eduadminConnectionError = response.data.data.relationships['activity-connections'].meta.data[0].meta.has_error
                    }

                    if (this.activityType == 'Restricted') {
                        this.showCopiedLink = false
                        this.activityTypeName = i18n.t('sharingSettingRestricted')
                    } else if (this.activityType == 'Flexible') {
                        this.showCopiedLink = true
                        this.activityTypeName = i18n.t('sharingSettingFlexible')
                    } else if (this.activityType  == 'Open') {
                        this.showCopiedLink = true
                        this.activityTypeName = i18n.t('sharingSettingOpen')
                    }
                }  
            } catch (e) {
                if(e.response){
                  if(e.response.status != 401 && e.response.status != 404){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                  }
                  if(e.response.status == 401){
                    this.flexibleData = true
                  }
                } 
            }
        }, 

        updateActivity(msg, type, name, cover, coverPath, sharingSettings, checkboxForum, checkboxCertificate, tags){
            this.alertType= type
            this.alertMsg = msg
            this.alertValue = true
            this.activityTitle = name
            this.coverImage = cover
            this.coverPath = coverPath
            this.sharingSetting = sharingSettings
            this.checkboxForum = checkboxForum
            this.checkboxCertificate = checkboxCertificate
            this.tags = tags
            eventBus.$emit('setSharingSettings', this.sharingSetting)
            if (this.sharingSetting == 1) {
                this.showCopiedLink = false
                this.activityTypeName = i18n.t('sharingSettingRestricted')
            } else if (this.sharingSetting == 2) {
                this.showCopiedLink = true
                this.activityTypeName = i18n.t('sharingSettingFlexible')
            } else if (this.sharingSetting  == 3) {
                this.showCopiedLink = true
                this.activityTypeName = i18n.t('sharingSettingOpen')
            }
        },
        async editTitle(){
            if(this.valid){
                // Vue.set(this.activityTitle, 'edit', !this.activityTitle.edit)
                    let data = {
                        data: {
                            type: "activities",
                            id: this.$route.params.id,
                            attributes: {
                                title: this.activityTitle.trim()
                            },
                            relationships: {
                                space: {
                                    data: {
                                        type: "spaces",
                                        id: this.spaceId
                                    }
                                }
                            }
                        }
                    };
                    try {
                        const response = await updateActivity(data.data.id, data)
                        if(response.status == 200) {
                           await this.getActivity()
                            //updated - do not show anything
                        }
                    } catch (e) {
                        if(e.response){
                            if (e.response.status == 403){
                                for(let i = 0; i < e.response.data.errors.length; i++){
                                    if(e.response.data.errors[i].detail == 'This action is unauthorized.'){
                                        this.$router.push({name: 'PageAccessDenied'})
                                    }
                                    else {
                                        this.alertValue = true
                                        this.alertType = 'error'
                                        this.alertMsg =  i18n.t('serverError')
                                    }
                                }
                            } else{
                                this.alertType = 'error'
                                this.alertMsg =  i18n.t('serverError') 
                                this.alertValue = true
                            }           
                        }
                    }
                     this.showActivityTitle = false
            }
        },
        async changeSharingSettings(id){
          if(id == null){
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg =  i18n.t('serverError')
            this.dialogVisibleChangeSharingSettings = false
          } else{
            this.loadingUpdate = true
            try{
                  let data = {
                      data: {
                          type: "activities",
                          id: this.activityId,
                          attributes: {
                              title: this.activityTitle
                          },
                            relationships: {
                                  space: {
                                      data: {
                                          type: "spaces",
                                          id: this.spaceId
                                      }
                                  },
                                  "sharing-setting": {
                                      data: {
                                          type: "sharing-settings",
                                          id: id
                                      }
                                  }
                              }
                      }
                  }
                  const response = await updateActivity(this.activityId, data)
                  if(response.status == 200) {
                      this.activityType = response.data.data.attributes.sharing_setting
                      this.sharingSetting = response.data.data.relationships['sharing-setting'].data.id
                      if (this.activityType == 'Restricted') {
                          this.showCopiedLink = false
                          this.activityTypeName = i18n.t('sharingSettingRestricted')
                      } else if (this.activityType == 'Flexible') {
                          this.showCopiedLink = true
                          this.activityTypeName = i18n.t('sharingSettingFlexible')
                      } else if (this.activityType  == 'Open') {
                          this.showCopiedLink = true
                          this.activityTypeName = i18n.t('sharingSettingOpen')
                      }
                      eventBus.$emit('setSharingSettings', this.sharingSetting)
                  }
              } catch (e) {
                  if(e.response){
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                  }
              }
            this.dialogVisibleChangeSharingSettings = false
            this.loadingUpdate = false
          }
        },
        showErrorMessage(){
          this.dialogVisibleOwners = false
          this.alertValue = true
          this.alertType = 'error'
          this.alertMsg =  i18n.t('serverError')
        },
        async sendRequestOwnerRights(){
          try {
            let data = {
              data: {
                type: "requests-owner-rights",
                  relationships: {
                    user: {
                      data: {
                        type: "users",
                        id: this.userId
                      }
                    },
                    requestable: {
                      data: {
                        type: "activities",
                        id: this.$route.params.id
                      }
                    }
                  }
              }
            };
            const response = await createRequestToBecomeOwner(data)
            if(response.status == 200) {
              this.alertValue = true
              this.alertType = 'success'
              this.alertMsg =  i18n.t('requestOwnerRightsSuccess')
              this.dialogRequestOwnerRights = false            
            }            
          } catch (e) {
              if(e.response){
                  if (e.response.status == 403){
                    this.$router.push({name: 'PageAccessDenied'})
                  } else if(e.response.status == 404) {
                    this.$router.push({name: 'PageNotFound'})
                  } else {
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                    this.dialogRequestOwnerRights = false 
                  }
              }            
          }
        }
    },
}
</script>
<style>
.activity-title .dots-vertical {
    display:block;
}
.activity-title .dots-vertical i::before{
  color: white;
}
.activity-title:hover .dots-vertical i::before{
  /* display: initial;
  vertical-align: initial; */
  color: var(--v-greytext-base) ;
}
.activity-title div{
  display: inline-flex;
}
</style>
